import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;
export default {
   

    async Proveedores_Detalle(vm, data) {

        return axios
            .post(
                `${domain.domainNameForApi}Proveedor/Proveedores_Detalle`,
                data
            )
            .then((response) => response.data);
    },
    async Proveedores_Telefonos(vm, prclave) {
        var formData = new FormData();
        formData.append("prclave", prclave);

        return axios
            .post(
                `${domain.domainNameForApi}Proveedor/Proveedores_Telefonos`,
                formData
            )
            .then((response) => response.data);
    },
    async Proveedores_Busqueda(vm,nombre, pagina) {
        var formData = new FormData();
        formData.append("nombre", nombre);
        formData.append("pagina", pagina);
        return axios
            .post(
                `${domain.domainNameForApi}Proveedor/MostrarProveedorBusqueda`,
                formData
            )
            .then((response) => response.data);
    },
    ObtenerSupervisorVehiculo(data) {
        return axios.post(`${domain.domainNameForApi}Proveedor/ObtenerSupervisorVehiculo`, data).then((response) => response.data);
    }
};
